import type {
	GetLocalizationDictionaryRequestParams,
	GetLocalizationDictionaryResponse,
} from './types';

const resolveAssetsUrl = (assetsApiUrl?: string) => {
	if (assetsApiUrl) {
		return assetsApiUrl.endsWith('/') ? assetsApiUrl : `${assetsApiUrl}/`;
	}

	const fromEnv =
		process.env.NEXT_PUBLIC_API_ASSETS_URL ||
		`${process.env.NEXT_PUBLIC_API_BASE || ''}/`;

	return fromEnv.endsWith('/') ? fromEnv : `${fromEnv}/`;
};

export const getLocalizationDictionary = async ({
	assetsApiUrl,
}: GetLocalizationDictionaryRequestParams = {}): Promise<GetLocalizationDictionaryResponse> => {
	try {
		const res = await fetch(
			`${resolveAssetsUrl(assetsApiUrl)}dictionaries/cityzens/cityzens.json`,
			{ method: 'GET' }
		);

		if (!res.ok) {
			return null;
		}

		return (await res.json()) as GetLocalizationDictionaryResponse;
	} catch {
		return null;
	}
};

/** @deprecated Prefer getLocalizationDictionary */
export const getLocalizationData = getLocalizationDictionary;
